import React from "react";
import RequestTerminalAccountForm from "../../../components/app/account-management/request-terminal-account/RequestTerminalAccountForm";

const NewRequestTerminalAccountPage = () => {
  return (
    <RequestTerminalAccountForm />
  )
}

export default NewRequestTerminalAccountPage;
